<div class="navbar-header">

    <img src='../../../../../../assets/images/logos/eguardlogo.png' style="width : 30px">

    <button mat-button class="toggle-button-navbar mat-icon-button" eguardNavbarVertical="closeBar" fxHide.gt-md>
        <mat-icon>arrow_back</mat-icon>
    </button>

</div>

<div class="navbar-content" eguardPerfectScrollbar>
    <eguard-navigation layout="vertical"></eguard-navigation>
</div>


// WEBPACK FOOTER //
// ./src/app/main/shared/components/navbar/vertical/navbar-vertical.component.html